// src/design-system/Organisms/OrderHistorySection/orderTable.data.ts
export type OrderRow = {
  id: number;
  product: string;
  total: string;
  date: string;
};

export const orderColumns = [
  { label: "Order ID", accessor: "id" },
  { label: "Product", accessor: "product" },
  { label: "Total Paid", accessor: "total" },
  { label: "Date Placed", accessor: "date" },
   { label: "Order Status", accessor: "orderStatus" },
] as const;
